<div class="sir-container" [class]="backgroundColor">
    <sirius-grid>
        @if (variant) {
            <div class="sir-text-container" [class.sir-text-context-on-dark]="variant === 'dark'">
                <div class="sir-text">
                    <sirius-heading
                        [text]="title"
                        textStyleCategory="display"
                        textStyleSize="m"
                        data-cy="hero-heading"></sirius-heading>
                    @if (textHtml) {
                        <sirius-text-html
                            class="sir-sub-title"
                            [html]="textHtml"
                            textStyleSize="l"
                            data-cy="hero-texthtml"></sirius-text-html>
                    }
                </div>
                @if (buttonPrimary || buttonSecondary) {
                    <div class="sir-buttons">
                        @if (buttonPrimary) {
                            <a
                                siriusButton
                                [siriusLink]="buttonPrimary.link"
                                [iconName]="buttonPrimary.iconName"
                                [buttonText]="buttonPrimary.link.title"
                                [buttonType]="buttonType"
                                data-cy="hero-btn-primary"></a>
                        }
                        @if (buttonSecondary) {
                            <a
                                siriusButton
                                [size]="'small'"
                                [siriusLink]="buttonSecondary.link"
                                [iconName]="buttonSecondary.iconName"
                                [buttonText]="buttonSecondary.link.title"
                                [buttonType]="buttonType"
                                data-cy="hero-btn-secondary"></a>
                        }
                    </div>
                }
            </div>
        }
        <div class="sir-image-container">
            <div class="sir-image">
                <sirius-image-item
                    [image]="image | cast"
                    [imageData]="imageData"
                    [fetchPriority]="'high'"
                    data-cy="hero-image"></sirius-image-item>
            </div>
        </div>
    </sirius-grid>
</div>
